import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';

export class Researchers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            researchers: [],
            deletedResearchers: null,
            search: '',
            activeTab: '1',
            dt: null
        };

        this.toggle = this.toggle.bind(this);
        this.handleFilterClick = this.handleFilterClick.bind(this);
        this.handleSearchChanged = this.handleSearchChanged.bind(this);
        this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
        this.handleResearcherDeleted = this.handleResearcherDeleted.bind(this);
        this.handleResearcherRestored = this.handleResearcherRestored.bind(this);
        this.deleteTabClicked = this.deleteTabClicked.bind(this);
        this.renderActiveTable = this.renderActiveTable.bind(this);
        this.renderDeletedTable = this.renderDeletedTable.bind(this);
    }

    componentDidMount() {
        var that = this;
        //not a great way to do this or the react way
        const script = document.createElement("script");
        script.onload = function () {
            that.populateResearchers();
        }
        script.src = "js/datatables.min.js"; //this also has jquery included inside since react scopes
        script.async = true;
        document.body.appendChild(script);
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) this.setState({ activeTab: tab });
    }

    handleFilterClick() {
        this.populateResearchers();
    }

    handleSearchChanged(e) {
        this.setState({ search: e.target.value });
    }

    handleSearchSubmit(e) {
        e.preventDefault();

        this.populateResearchers();
    }

    handleResearcherDeleted(id) {
        if (!window.confirm('Are you sure you want to delete?')) {
            return;
        }

        var url = 'api/contacts/delete-researcher?id=' + id;
        fetch(url).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    this.populateDeletedResearchers();
                    this.populateResearchers();
                } else {
                    console.error("Submission error", response);
                }
            })
        });
    }

    handleResearcherRestored(id) {
        var url = 'api/contacts/restore-researcher?id=' + id;
        fetch(url).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    this.populateDeletedResearchers();
                    this.populateResearchers();
                } else {
                    console.error("Submission error", response);
                }
            })
        });
    }

    deleteTabClicked() {
        if (!this.state.deletedResearchers) {
            this.populateDeletedResearchers();
        }
    }

    renderActiveTable() {
        if (this.state.researchers && this.state.researchers.length) {
            return (
                <table id="activeResearchers" className="table table-striped my-3 pt-2 dt">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>College</th>
                            <th>Department</th>
                            <th>Areas of Interest</th>
                            <th>Number of Contacts</th>
                            <th width="20%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.researchers && this.state.researchers.map(researcher =>
                            <tr key={researcher.id}>
                                <td>{researcher.name}</td>
                                <td>{researcher.email}</td>
                                <td>{researcher.institution ? researcher.institution.label : ""}</td>
                                <td>{researcher.subInstitution ? researcher.subInstitution.label : ""}</td>
                                <td>{researcher.labelEntities ? <ul className="list-unstyled m-0">{researcher.labelEntities.map(area => <li key={area.id}>{area.label}</li>)}</ul> : ""}</td>
                                <td>{researcher.contacts ? researcher.contacts.length : ""}</td>
                                <td className="text-right"><a className="btn btn-info btn-sm" href={'/edit-researcher?id=' + researcher.id} title="Edit"><FontAwesomeIcon icon="eye" /></a> <button type="button" className="btn btn-danger btn-sm" onClick={() => this.handleResearcherDeleted(researcher.id)} title="Delete"><FontAwesomeIcon icon="trash" /></button></td>
                            </tr>
                        )}
                    </tbody>
                </table>
            );
        }

        return (
            <p className="alert alert-warning m-3">There are currently no researchers. You should add some.</p>
        );
    }

    renderDeletedTable() {
        if (this.state.deletedResearchers && this.state.deletedResearchers.length) {
            return (
                <table id="deletedResearchers" className="table table-striped my-3">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th width="20%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.deletedResearchers && this.state.deletedResearchers.map(researcher =>
                            <tr key={researcher.id}>
                                <td>{researcher.name}</td>
                                <td>{researcher.email}</td>
                                <td className="text-right"><a className="btn btn-info btn-sm" href={'/edit-researcher?id=' + researcher.id}><FontAwesomeIcon icon="eye" /></a> <button type="button" className="btn btn-success btn-sm" onClick={() => this.handleResearcherRestored(researcher.id)} title="Reactivate"><FontAwesomeIcon icon="trash-restore" /></button></td>
                            </tr>
                        )}
                    </tbody>
                </table>
            );
        }

        return (
            <p className="alert alert-warning m-3">There are currently no deleted researchers.</p>
        );
    }

    render() {
        let activeResearchersTable = this.state.researchers
            ? this.renderActiveTable()
            : <p className="alert alert-warning m-3">Loading...</p>;
        let deletedResearchers = this.state.deletedResearchers
            ? this.renderDeletedTable()
            : <p className="alert alert-warning m-3">Loading...</p>;

        return (
            <div>
                <h1>Researchers</h1>
                <hr />
                <form className="form-inline my-4" onSubmit={this.handleSearchSubmit}>
                    <a href="/add-researcher" className="btn btn-success mb-3 mr-sm-3">Add Researcher</a>
                    <div className="input-group mb-3">
                        <input id="txtSearch" type="text" className="form-control" aria-label="Search" value={this.state.search} onChange={this.handleSearchChanged} />
                        <div className="input-group-append">
                            <button className="btn btn-outline-secondary" type="submit">Filter</button>
                        </div>
                    </div>
                </form>
                <Nav tabs>
                    <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggle('1'); }}>Active</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => { this.toggle('2'); this.deleteTabClicked(); }}>Deleted</NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab} className="py-3">
                    <TabPane tabId="1">
                        {activeResearchersTable}
                    </TabPane>
                    <TabPane tabId="2">
                        {deletedResearchers}
                    </TabPane>
                </TabContent>
            </div>
        );
    }

    async populateResearchers() {
        const params = new URLSearchParams({ search: this.state.search });
        const response = await fetch('api/contacts/get-researchers?' + params);
        const data = await response.json();

        if (this.state.dt) {
            this.state.dt.destroy();
        }
        this.setState({ researchers: data, loading: false });
        this.setState({ dt: window.$("table.dt").DataTable({ order: [], lengthMenu: [[25, 50, 100, -1], [25, 50, 100, "All"]], }) });
    }

    async populateDeletedResearchers() {
        const params = new URLSearchParams({ search: this.state.search, getDeleted: true });
        const response = await fetch('api/contacts/get-researchers?' + params);
        const data = await response.json();

        this.setState({ deletedResearchers: data });
    }
}